module.exports = __webpack_public_path__ + "img/icon (12).a4e67e14.png";